import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup,UntypedFormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { CustomerService } from '../../services/customer.service';
import { PaymentsService } from '../../services/payments.service';
import { StripeService, buildStripeBillingAddressFromCustomerContext } from '../../services/stripe.service';

@Component({
	selector: 'app-credit-card-form',
	templateUrl: './credit-card-form.component.html',
	styleUrls: ['./credit-card-form.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		])
	]
})
export class CreditCardFormComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
	@Input() customer: any = [];
	@Input() branches: any = [];
	@Input() type: any = '';
	@Input() arpreauth: any = false;
	@Output() updatePayments: EventEmitter < any > = new EventEmitter();

	@ViewChild('thirdparty') thirdpartyRef: ElementRef;
	@ViewChild('stripeCardContainer') stripeCardContainer: ElementRef<HTMLDivElement>;

	flip = 'inactive';
	payment_methods: any = [];
	bankaccounts: any = [];
	today = new Date();
	day_payments: any = [];
	cardForm: UntypedFormGroup;
	selectedCard = new UntypedFormControl('');
	searchByAmount = new UntypedFormControl('');
	searchByInvoice = new UntypedFormControl('');
	searchString = new UntypedFormControl('');
	customerSearchInline = new UntypedFormControl('');
	customerSearchResultsTwo: any = [];
	searchByCurrentPayments= new UntypedFormControl('');
	searchByCurrentInvoices= new UntypedFormControl('');

	selectAllPayments= new UntypedFormControl(false);
	selectAllInvoices= new UntypedFormControl(false);
	selectInvoiceToPay= new UntypedFormControl(false);

	searchByCurrentPaymentsDate= new UntypedFormControl('');
	searchByCurrentInvoicesDate = new UntypedFormControl('');
	holdReason = new UntypedFormControl('');

	alldebits: any = false;
	allcredits: any = false;

	//reversed
	singleusecard = new UntypedFormControl(true);
	currency: any = '';
	currencies: any = [];
	company: any = [];

	//paymentss
	datefrom = new Date()
	dateto = new Date()
	running = false;
	total_pay: any = '';
	payments: any = [];

	customersearching: any = false;
	customerSearchResults: any = [];
	amountResults: any = false;
	invoiceResults: any = false;
	customertransactions: any = [];

	hasprofile = false;
	payment_added: any = false;
	addingcard: any = false;

	allocations_from: any = [];
	allocations_to: any = [];

	allocation_from_total = 0.00;
	allocation_to_total = 0.00;
	profile_cards: any = [];

	payment_card: any = false;
	single_use: any = false;
	editingcard: any = false;
	sending: any = false;
	color = 'blue';
	charge_card = true;
	submitting = false;
	chargetype = 'existing_card';
	chargecardtype = 'no_charge';
	card_required = false;
	thirdpartylinks: any = false;
	showrefunds = false;
	urlSafe: SafeResourceUrl;
	creditsSelected: any = [];
	expandedElement: any = false;
	hidepay: any = false;
	debitsSelected: any = [];

	allpayments:any = [];
	alltransactions:any = [];
	holdreasons:any = [];
	token: any = false;
	config: any = false;
	stripeGatewayActive = false;
	useStripe = false;
	stripeUnconfigured = false;
	stripeMounted = false;
	stripePublishableKey = '';
	/** CardPointe iframe URL from server (payments/creditcards/stripeconfig) when PAYMENT_GATEWAY is CardConnect. */
	cardconnectTokenizerSrc = '';
	cardconnectTokenizerTokenProp = 'message';
	/** False until getStripeClientConfig() resolves — avoids ngOnChanges building the wrong form before Stripe flags exist (order entry / *ngIf tabs). */
	private stripeGatewayConfigLoaded = false;
	private tokenizerMessageListenerBound = false;
	/** Bumped after a successful save or customer switch so the CardConnect iframe reloads with empty fields. */
	tokenizerIframeNonce = 0;

	constructor(private modalService: NgbModal, public sanitizer: DomSanitizer, private ordersService: OrdersService, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private paymentsService: PaymentsService, private fb: UntypedFormBuilder, private customerService: CustomerService, private route: ActivatedRoute, public router: Router, private stripeService: StripeService, private cdr: ChangeDetectorRef) {

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.holdreasons.subscribe( r => {
			this.holdreasons = r;
		})
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.reconcileStripeUiAfterConfigChange();
			const sp = this.cardForm?.get('savetoprofile');
			if (sp) {
				sp.setValue(this.globalSearchService.getSaveToProfileDefault());
			}
		});
	}

	/** Static config iframe URL (legacy) or CardConnect tokenizer from API. */
	get effectiveTokenizerIframeUrl(): string {
		let raw = '';
		if (this.cardconnectTokenizerSrc) {
			raw = this.cardconnectTokenizerSrc;
		} else {
			const f = this.config?.features?.iframe;
			if (typeof f === 'string' && f.trim() !== '' && f !== 'false') {
				raw = f;
			}
		}
		return raw ? this.appendCardconnectTokenizerCssIfNeeded(raw) : '';
	}

	/** Same tokenizer URL as `effectiveTokenizerIframeUrl` plus a nonce so `app-iframe-view` reloads the iframe when it changes. */
	get tokenizerIframeSrcForView(): string {
		const base = this.effectiveTokenizerIframeUrl;
		if (!base) {
			return '';
		}
		try {
			const u = new URL(base);
			u.searchParams.set('_ccb', String(this.tokenizerIframeNonce));
			return u.toString();
		} catch {
			return base;
		}
	}

	/**
	 * CardPointe loads custom CSS via the `css=` query param (fetched inside the iframe by CardConnect's JS).
	 * The CSS file lives as a static Angular asset at `/assets/css/cardconnect-tokenizer.css`.
	 * Using the Angular app's own origin guarantees the file is publicly reachable (no API auth needed).
	 * Optional override: `features.tokenizerCssUrl` (full HTTPS URL to CSS).
	 */
	private appendCardconnectTokenizerCssIfNeeded(src: string): string {
		try {
			const u = new URL(src);
			if (!/\.cardconnect\.com$/i.test(u.hostname) || u.pathname.indexOf('/itoke/ajax-tokenizer') === -1) {
				return src;
			}
			const existing = u.searchParams.get('css')?.trim();
			if (existing) {
				if (!u.searchParams.get('orientation')?.trim()) {
					u.searchParams.set('orientation', 'horizontal');
					return u.toString();
				}
				return src;
			}
			const explicit = this.config?.features?.tokenizerCssUrl;
			if (typeof explicit === 'string' && explicit.trim() !== '') {
				u.searchParams.set('css', explicit.trim());
			} else {
				const cssUrl = window.location.origin + '/assets/css/cardconnect-tokenizer.css';
				u.searchParams.set('css', cssUrl);
			}
			if (!u.searchParams.get('orientation')?.trim()) {
				u.searchParams.set('orientation', 'horizontal');
			}
			return u.toString();
		} catch {
			return src;
		}
	}

	private ensureTokenizerMessageListener(): void {
		if (this.tokenizerMessageListenerBound || typeof window === 'undefined') {
			return;
		}
		this.tokenizerMessageListenerBound = true;
		const parent = this;
		window.addEventListener('message', (event: MessageEvent) => {
			if (event.data == null) {
				return;
			}
			try {
				const u = new URL(event.origin || '');
				if (u.protocol !== 'https:' || !/\.cardconnect\.com$/i.test(u.hostname)) {
					return;
				}
			} catch {
				return;
			}
			parent.applyTokenizerPostMessage(event.data);
		}, false);
	}

	private applyTokenizerPostMessage(raw: unknown): void {
		let p: any;
		if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
			p = raw;
		} else if (typeof raw === 'string') {
			try {
				p = JSON.parse(raw);
			} catch {
				return;
			}
		} else {
			return;
		}
		if (p?.cssLoaded) {
			return;
		}
		const prop = this.cardconnectTokenizerTokenProp || 'message';
		const tok = p?.[prop] ?? p?.message ?? p?.account ?? p?.token;
		const patch: any = {};
		if (tok != null && String(tok).trim() !== '') {
			patch.token = String(tok).trim();
		}
		let em = '';
		let ey = '';
		if (p?.expiry) {
			const d = String(p.expiry).replace(/\D/g, '');
			if (d.length >= 4) {
				em = d.slice(0, 2);
				ey = d.slice(2, 4);
			}
		}
		if (p?.expirymm && p?.expiryyy) {
			em = String(p.expirymm).replace(/\D/g, '').slice(0, 2);
			ey = String(p.expiryyy).replace(/\D/g, '').slice(-2);
		}
		if (p?.expiryMonth && p?.expiryYear) {
			em = String(p.expiryMonth).replace(/\D/g, '').slice(0, 2);
			ey = String(p.expiryYear).replace(/\D/g, '').slice(-2);
		}
		if (em && ey) {
			patch.expiry_month = em;
			patch.expiry_year = ey;
		}
		const cv = p?.cvv ?? p?.cvc ?? p?.cvd;
		if (cv != null && String(cv).trim() !== '') {
			patch.cvv = String(cv).trim();
		}
		if (p?.card_type != null && String(p.card_type).trim() !== '') {
			patch.card_type = String(p.card_type).trim();
		}
		if (Object.keys(patch).length === 0) {
			return;
		}
		this.cardForm?.patchValue(patch);
		if (patch.token) {
			this.token = patch.token;
		}
		this.cdr.detectChanges();
	}

	ngOnInit(): void {
		this.ensureTokenizerMessageListener();
		this.initStripeClientConfig();
	}

	private initStripeClientConfig(): void {
		this.paymentsService.getStripeClientConfig().subscribe({
			next: (cfg: any) => {
				this.applyCardconnectTokenizerConfig(cfg);
				this.applyStripeGatewayConfig(cfg);
				this.ensureTokenizerMessageListener();
				this.stripeGatewayConfigLoaded = true;
				if (this.customer?.debtorno) {
					this.setCardForm();
				}
			},
			error: () => {
				this.cardconnectTokenizerSrc = '';
				this.stripeGatewayActive = false;
				this.stripePublishableKey = '';
				this.useStripe = false;
				this.stripeUnconfigured = false;
				this.stripeGatewayConfigLoaded = true;
				this.ensureTokenizerMessageListener();
				if (this.customer?.debtorno) {
					this.setCardForm();
				}
			},
		});
	}

	private applyCardconnectTokenizerConfig(cfg: any): void {
		const gw = String(cfg?.gateway ?? '').toLowerCase();
		if (gw === 'cardconnect' && cfg?.tokenizer_iframe_src && !cfg?.tokenizer_config_error) {
			this.cardconnectTokenizerSrc = String(cfg.tokenizer_iframe_src);
			this.cardconnectTokenizerTokenProp = cfg?.tokenizer_token_property_name || 'message';
		} else {
			this.cardconnectTokenizerSrc = '';
			this.cardconnectTokenizerTokenProp = 'message';
		}
	}

	private applyStripeGatewayConfig(cfg: any): void {
		this.stripeGatewayActive = !!cfg?.requires_stripe_js;
		this.stripePublishableKey = cfg?.publishable_key || '';
		const tokenizerBlocksPan = !!this.effectiveTokenizerIframeUrl;
		this.useStripe = this.stripeGatewayActive && this.stripePublishableKey !== '' && !tokenizerBlocksPan;
		this.stripeUnconfigured = this.stripeGatewayActive && this.stripePublishableKey === '' && !tokenizerBlocksPan;
	}

	/** Global config (e.g. features.iframe) may arrive before or after Stripe adapter config — keep useStripe and the form in sync. */
	private reconcileStripeUiAfterConfigChange(): void {
		if (!this.stripeGatewayConfigLoaded) {
			return;
		}
		const tokenizerBlocksPan = !!this.effectiveTokenizerIframeUrl;
		const wantStripe = this.stripeGatewayActive && this.stripePublishableKey !== '' && !tokenizerBlocksPan;
		this.stripeUnconfigured = this.stripeGatewayActive && this.stripePublishableKey === '' && !tokenizerBlocksPan;
		const prev = this.useStripe;
		this.useStripe = wantStripe;
		if (prev !== wantStripe && this.customer?.debtorno) {
			this.stripeService.unmountCardElement();
			this.stripeMounted = false;
			this.setCardForm();
			return;
		}
		if (this.useStripe && this.customer?.debtorno && !this.stripeMounted) {
			this.cdr.detectChanges();
			setTimeout(() => this.mountStripeCard(), 0);
		}
	}

	/** Card-not-present: require CVV for any non-Stripe flow (PAN or CardPointe iframe + separate CVV / auth). */
	private cnpCvvRequired(): boolean {
		return !this.useStripe;
	}

	private usesTokenizerIframe(): boolean {
		return !!this.effectiveTokenizerIframeUrl && !this.useStripe;
	}

	/** Clear gateway token and force tokenizer iframe reload, then rebuild the form (after save or customer change). */
	private resetTokenizerStateForNewEntry(): void {
		this.token = '';
		if (this.usesTokenizerIframe()) {
			this.tokenizerIframeNonce++;
		}
		this.setCardForm();
		this.cdr.detectChanges();
	}

	ngAfterViewInit(): void {
		if (this.useStripe && this.customer?.debtorno && !this.stripeMounted) {
			setTimeout(() => {
				this.mountStripeCard();
			}, 100);
		}
	}

	loadCustomer() {

		this.paymentsService.getCustomerAccountReceivables(this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			this.customer = results;

			this.holdReason.setValue(results.holdreason);
			this.searchString.setValue(results.name);

			this.loadProfile(results.debtorno, results.branchcode);

			this.customertransactions = results.transactions;
			this.allcredits = results.payments
			this.alldebits = results.transactions

			this.alltransactions = results.transactions;
			this.allpayments = results.payments;

			this.setCardForm();

		});
	}

	toggleFlip() {
		this.flip = (this.flip == 'active') ? 'inactive': 'active';
	}

	loadProfile(debtorno: any, branchcode: any) {

		this.paymentsService.loadProfile(debtorno, branchcode).subscribe(async (result: any) => {
			if (result.cards) {
				this.hasprofile = true;
				this.profile_cards = result.cards
				this.payment_card = result.cards.filter((card: any) => {
					return card.default
				})[0];

				if(!this.payment_card.length) {
					this.payment_card = result.cards[0]
				}


				this.updatePaymentType(this.payment_card.payment_method);

			} else {
				this.hasprofile = false;
				this.profile_cards = [];
				this.payment_card = false;

			}
		})
	}

	setCardForm() {
		const branchcodeValue = this.customer?.branchcode || (this.branches?.length > 0 ? this.branches[0]?.branchcode : '');
		const base: any = {
			debtorno: [this.customer?.debtorno, Validators.required],
			branchcode: [branchcodeValue, Validators.required],
			name: [this.customer?.name || '', Validators.required],
			token: [this.token || ''],
			card_id: [true],
			savetoprofile: [this.globalSearchService.getSaveToProfileDefault(), Validators.required]
		};
		this.stripeService.unmountCardElement();
		this.stripeMounted = false;
		if (this.useStripe) {
			this.cardForm = this.fb.group(base);
			this.cdr.detectChanges();
			setTimeout(() => this.mountStripeCard(), 0);
		} else if (this.usesTokenizerIframe()) {
			// CVV is collected inside the CardConnect iframe; many builds do not echo CVV in postMessage (PCI).
			// Backend accepts empty cvd when a gateway token is present. Do not require cvv on this form.
			this.cardForm = this.fb.group({
				...base,
				token: [this.token || '', Validators.required],
				expiry_month: [''],
				expiry_year: [''],
				cvv: [''],
				card_type: [''],
			});
		} else {
			const cvvValidators = this.cnpCvvRequired() ? [Validators.required] : [];
			this.cardForm = this.fb.group({
				...base,
				ccnumber: ['', Validators.required],
				expiry: ['', Validators.required],
				cvv: ['', cvvValidators]
			});
		}
	}

	ngOnDestroy() {
		if (this.useStripe) {
			this.stripeService.unmountCardElement();
		}
	}

	private mountStripeCard(): void {
		if (!this.stripePublishableKey || !this.useStripe) return;
		if (this.stripeMounted) return;
		const tryMount = (delay: number, attemptsLeft: number) => {
			setTimeout(() => {
				if (!this.useStripe || this.stripeMounted) return;
				const el = this.stripeCardContainer?.nativeElement;
				if (!el) {
					if (attemptsLeft > 0) {
						tryMount(200, attemptsLeft - 1);
					}
					return;
				}
				this.stripeService.init(this.stripePublishableKey).then(ok => {
					if (!ok || !this.useStripe || this.stripeMounted) return;
					this.stripeService.mountCardElement(el).then(() => {
						this.stripeMounted = true;
						this.cdr.detectChanges();
					}).catch(() => {
						if (attemptsLeft > 0) {
							tryMount(200, attemptsLeft - 1);
						}
					});
				}).catch(() => {
					if (attemptsLeft > 0) {
						tryMount(200, attemptsLeft - 1);
					}
				});
			}, delay);
		};
		tryMount(100, 10);
	}


	setCardRequired(method: any) {

	}

	updatePaymentType(method : any) {

		this.setCardRequired(method);
	}

	updateProfile(event: any) {
		this.customer.profile = event;
		this.addingcard = false;
		this.editingcard = false;
		this.sending = false;
		this.profile_cards = event.cards
		this.hasprofile = (event.cards.length) ? true :false;
		this.profile_cards = event.cards
	}

	toggleAddCard() {
		this.addingcard = (this.addingcard) ? false : true
	}


	doNotCharge(event: any) {
		event.preventDefault();
		this.payment_card = false;
		this.charge_card = false;

		this.profile_cards.every(card => card.default = false);
	}

	addPayment(event: any) {
		event.preventDefault();
	}

	hidePayments() {
		this.hidepay = (this.hidepay) ? false :true;
	}



	selectCustomer(customer: any) {
		//todo dont do this


		this.customersearching = false;
		this.customerSearchInline.setValue(customer.name);
		this.customer = customer;
		this.loadCustomer();
		//this.router.navigate(['/receivables/payment-entry/' + customer.debtorno + '/' + customer.branchcode]);
	}

	customerSearchtwo(event: any) {

		if (this.customersearching) {
			this.customersearching.unsubscribe()
		}

		const search = {
			keywords: event
		}

		this.customersearching = this.customerService.getCustomerSearch(search).subscribe(async (results: any) => {
			this.customerSearchResultsTwo = results;

			if(results.length == 1) {
				this.selectCustomer(results[0])
				this.customerSearchResults = false;
				this.customerSearchResultsTwo = false;
			}

		});
	}

	paymentTotals(): number {

		let balance = (this.allocation_to_total + this.allocation_from_total);
		if(balance >= 0 ) {
			balance = 0.00
		}
		return balance;
	}

	singleFormSet(event: any) {


	}

	editCard(event: any, card: any) {
		event.stopPropagation();
		event.preventDefault();

		this.editingcard = true;
		const cvvValidators = this.cnpCvvRequired() ? [Validators.required] : [];
		this.cardForm = this.fb.group({
			debtorno: [this.customer.debtorno, Validators.required],
			branchcode: [this.customer.branchcode, Validators.required],
			name: [card.name, Validators.required],
			ccnumber: [card.number, Validators.required],
			card_id: [card.card_id, Validators.required],
			expiry: [card.expiry_month+'/'+card.expiry_year, Validators.required],
			cvv: ['', cvvValidators],
			savetoprofile: [this.globalSearchService.getSaveToProfileDefault(), Validators.required]
		});

	}

	updateCard(event:any) {
		event.stopPropagation();
		event.preventDefault();

		if(this.cardForm.valid) {
			this.sending = true;
			this.paymentsService.editCreditCard(this.cardForm.value).subscribe( (result: any) => {
				this.sending = false;
				if(!result.success) {
					alert(result.message)
				} else {

					if (result.cards) {
						this.hasprofile = true;
						this.profile_cards = result.cards
						this.payment_card = result.cards.filter((card: any) => {
							return card.default
						})[0];
					}

					this.editingcard = false;
				}
			});
		}

	}

	removeCard(event: any) {

		event.stopPropagation();
		event.preventDefault();
		this.sending = true;
		this.paymentsService.removeCreditCard(this.cardForm.value).subscribe( (result: any) => {
			this.sending = false;
			this.hasprofile = (result.cards.length) ? true :false;
			this.editingcard = false;
			this.profile_cards = result.cards
			this.payment_card = result.cards.filter((card: any) => {
				return card.default
			})[0];

		});
	}

	addPaymentMethod(event: any) {
		event.preventDefault();
		if (this.useStripe) {
			if (!this.cardForm.get('name')?.value?.trim() || !this.stripeMounted) {
				alert('Enter card holder name and card details.');
				return;
			}
			if (!this.stripeService.canCreatePaymentMethod()) {
				this.stripeMounted = false;
				this.cdr.detectChanges();
				alert('Secure card fields are not ready. Please wait for the form to load or refresh the page and try again.');
				return;
			}
			this.sending = true;
			const branchCode = this.cardForm.get('branchcode')?.value;
			const branch = this.branches?.find((b: any) => String(b?.branchcode) === String(branchCode));
			const billingAddr = buildStripeBillingAddressFromCustomerContext(branch, this.customer);
			this.stripeService.createPaymentMethod(this.cardForm.get('name')?.value?.trim(), billingAddr).then(res => {
				if (res.error) {
					this.sending = false;
					if (!this.stripeService.canCreatePaymentMethod()) this.stripeMounted = false;
					this.cdr.detectChanges();
					alert(res.error);
					return;
				}
				const payload = {
					...this.cardForm.value,
					payment_method: res.paymentMethodId,
					name: this.cardForm.get('name')?.value?.trim()
				};
				this.paymentsService.addCreditCard(payload).subscribe((result: any) => {
					this.sending = false;
					if (!result.success) {
						alert(result.message);
					} else {
						this.editingcard = false;
						this.hasprofile = true;
						if (result.cards) {
							this.profile_cards = result.cards;
							this.payment_card = result.cards.filter((c: any) => c.default)[0] || result.cards[0];
						}
						this.updatePayments.emit(result);
						this.stripeService.unmountCardElement();
						this.stripeMounted = false;
						this.resetTokenizerStateForNewEntry();
					}
				});
			});
			return;
		}
		if (this.cardForm.valid) {
			this.sending = true;
			this.paymentsService.addCreditCard(this.cardForm.value).subscribe((result: any) => {
				this.sending = false;
				if (!result.success) {
					alert(result.message);
				} else {
					this.editingcard = false;
					this.hasprofile = true;
					if (result.cards) {
						this.profile_cards = result.cards;
						this.payment_card = result.cards.filter((c: any) => c.default)[0] || result.cards[0];
					}
					this.updatePayments.emit(result);
					this.resetTokenizerStateForNewEntry();
				}
			});
		}
	}
	setChargeCardType(event:any) {
		this.chargecardtype = event.value
	}
	setChargeType(event: any) {
		this.chargetype = event.value
		this.updatePaymentType(event.value)
	}

	back() {
		//this.location.back()
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.customer && changes.customer.currentValue?.debtorno) {
			const prev = changes.customer.previousValue;
			const cur = changes.customer.currentValue;
			const debtornoChanged = !!prev?.debtorno && prev.debtorno !== cur.debtorno;
			if (debtornoChanged) {
				this.token = '';
				if (this.usesTokenizerIframe()) {
					this.tokenizerIframeNonce++;
				}
			}
			if (!this.stripeGatewayConfigLoaded) {
				// getStripeClientConfig() will call setCardForm when ready (ngOnChanges can run before ngOnInit).
			} else if (!this.cardForm) {
				this.setCardForm();
			} else if (debtornoChanged) {
				this.setCardForm();
				if (this.useStripe && !this.stripeMounted) {
					this.cdr.detectChanges();
					setTimeout(() => this.mountStripeCard(), 0);
				}
			} else {
				if (this.cardForm.get('branchcode') && this.customer?.branchcode) {
					this.cardForm.get('branchcode').setValue(this.customer.branchcode);
				}
				if (this.useStripe && !this.stripeMounted) {
					this.cdr.detectChanges();
					setTimeout(() => this.mountStripeCard(), 0);
				}
			}
		}
		if (changes.branches && changes.branches.currentValue?.length && this.cardForm) {
			if (this.cardForm.get('branchcode') && !this.cardForm.get('branchcode').value && this.branches[0]?.branchcode) {
				this.cardForm.get('branchcode').setValue(this.branches[0].branchcode);
			}
		}
		if (changes.customer && !changes.customer.currentValue?.debtorno) {
			this.loadCustomer();
		}
	}
}
